export default __webpack_public_path__ + "static/media/right_arrow_disabled_icon.5ab7f5ff.svg";